import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ApplyEgressApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'apply-egress'
  }

}